module.exports = __webpack_public_path__ + "mobile/img/customer-banner.8433e65d.png";